<p>
    Brix Builder is an arcade inspired stacking game. It is part of a mobile web
    game suite I did in 2016. It features 3 difficulties with 7 levels of
    increasing difficulty.
</p>
